<!-- New generic custom table as per new PCS portal redesign -->

<div class="container-fluid table-container">
  <!-- composed via toolbar, grid and footer child components -->
  <app-common-table-toolbar
    [showColumnSelectAccordion]="showColumnSelectAccordion"
    [showFilterAccordion]="showFilterAccordion"
    [columns]="columns"
    [loading]="loading"
    [selectableRows]="selectableRows"
    [disableDownload]="disableDownload"
    [dynamicPagination]="dynamicPagination"
    [rowsLength]="rows?.length || 0"
    [lowerCaseInput]="lowerCaseInput"
    [filterItems]="inputFilters"
    [tableName]="tableName"
    (columnSelectionChanged)="handleColumnSelection($event)"
    (filtersChanged)="handleFiltersChange($event)"
    (downloadEvent)="download($event)"
    [middleActions]="middleActions"
  ></app-common-table-toolbar>

  @if (!loading) {
    <app-common-table-grid
      [tableName]="tableName"
      [columns]="columns"
      [currentPage]="currentPage"
      [tableRows]="tableRows"
      [customGrandTotal]="customGrandTotal"
      [showSelectAllCheckbox]="showSelectAllCheckbox"
      [areAllRowsSelected]="areAllRowsSelected"
      [sortOrders]="sortOrders"
      [backgroundColors]="backgroundColors"
      [emptyValues]="emptyValues"
      [weekDays]="weekDays"
      [daysOfWeek]="daysOfWeek"
      [findColumnValueTotal]="findColumnValueTotal"
      [computeMomTrend]="computeMomTrend"
      [exclusionTypes]="exclusionTypes"
      [handlers]="gridHandlers"
    ></app-common-table-grid>
  }

  <app-common-table-footer
    [loading]="loading"
    [showPagination]="showPagination"
    [pageNumber]="pageNumber"
    [disabled]="loading"
    [dynamicPagination]="dynamicPagination"
    [exactRows]="exactRows"
    [pageSize]="pageSize"
    [tableRows]="tableRows"
    [totalRowsPayload]="totalRowsPayload"
    (pageChanged)="handlePaginationChange($event)"
  ></app-common-table-footer>
</div>
